import clsx, { type ClassValue } from 'clsx'

/**
 * Helper para concatenar classNames condicionais. Wrapper enxuto do clsx.
 * (Não usa tailwind-merge por simplicidade; conflitos quando necessário
 * são resolvidos passando a classe certa por último.)
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
